module.exports = __webpack_public_path__ + "img/mysql.c02ade79.svg";